import React, { useState } from 'react';
import { Drawer } from 'antd';
import CostPeriodicPricingList from './CostPeriodicPricingList';
import CostPeriodicCreateSchemeComp from './CostPeriodicCreateSchemeComp';

interface Props {
  businessScenario: number | null;
}

type ViewMode = 'list' | 'create' | 'edit' | 'view';

const CostPeriodicPricingPage: React.FC<Props> = ({ businessScenario }) => {
  const [mode, setMode] = useState<ViewMode>('list');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerKey, setDrawerKey] = useState(0);
  const [selectedSchemeId, setSelectedSchemeId] = useState<number | null>(null);
  const [listRefreshKey, setListRefreshKey] = useState(0);

  const openDrawer = (m: ViewMode, id?: number) => {
    setMode(m);
    setSelectedSchemeId(id ?? null);
    setDrawerKey(k => k + 1);
    setDrawerOpen(true);
  };

  const closeDrawer = () => setDrawerOpen(false);

  const handleSaveSuccess = () => {
    setDrawerOpen(false);
    setListRefreshKey(k => k + 1);
  };

  const drawerTitle =
    mode === 'create' ? '新建方案/New Plan' :
    mode === 'edit'   ? '编辑方案/Edit Plan' :
                        '查看方案/View Plan';

  return (
    <div className="mb-6">
      <CostPeriodicPricingList
        businessScenario={businessScenario}
        onCreateClick={() => openDrawer('create')}
        onEditClick={id => openDrawer('edit', id)}
        onViewClick={id => openDrawer('view', id)}
        refreshKey={listRefreshKey}
      />
      <Drawer
        title={drawerTitle}
        width={1000}
        open={drawerOpen}
        onClose={closeDrawer}
        maskClosable={false}
        styles={{ body: { paddingBottom: 80 } }}
      >
        <CostPeriodicCreateSchemeComp
          key={drawerKey}
          businessScenario={businessScenario}
          pricingSchemeId={selectedSchemeId}
          viewMode={mode === 'list' ? 'create' : mode}
          onSaveSuccess={handleSaveSuccess}
          onCancel={closeDrawer}
        />
      </Drawer>
    </div>
  );
};

export default CostPeriodicPricingPage;
